import classNames from 'classnames';
import trackerAttributes from '@common/Tracking/NavFrom/constants/TrackedDataAttr';
import { LeftNavigationItem } from './LeftNavigationItem';
import '../styles/LeftNavigationItemGroup.scss';

export function LeftNavigationItemGroup({
    persistedFiltersGroup,
    items,
    isSubMenu = false,
    customClass,
    isCountHidden
}) {
    const {
        side_cat: trackSidebarCategory,
        side_sub: trackSidebarSubcategory
    } = trackerAttributes;

    const trackingId = isSubMenu ? trackSidebarSubcategory : trackSidebarCategory;

    if (!items || !items.length) {
        return null;
    }

    const nonViewAllItems = items.filter(item => !item.isViewAll);

    return (
        <ul
            className={classNames({
                'left-navigation-group': true,
                'left-navigation-group--children': isSubMenu,
                [customClass]: typeof customClass !== 'undefined'
            })}
        >
            { nonViewAllItems.map(item => (
                <LeftNavigationItem
                    key={item.navigationId || item.name}
                    isCountHidden={isCountHidden}
                    isLoneChild={nonViewAllItems.length === 1}
                    isSubMenu={isSubMenu}
                    item={item}
                    persistedFiltersGroup={persistedFiltersGroup}
                    trackingId={trackingId}
                />
            ))}
        </ul>
    );
}
